export default __webpack_public_path__ + "static/media/icon-add-to-cart.43b32c7b.svg";